import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { GeofenceContract } from '@polaris-customerweb/sharedcomponents.core';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Geofence } from '@polaris-customerweb/sharedcomponents.user-content';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GeofenceResourceService {
    private baseUrl: string;

    constructor(
        configService: ConfigService,
        private http: HttpClient,
        private routingHelpersService: RoutingHelpersService
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.rideCommand,
            'geofeatures/geofence'
        );
    }

    getGeofencesForUser(): Observable<Geofence[]> {
        return this.http
            .get<GeofenceContract[]>(this.baseUrl)
            .pipe(
                map((contracts) =>
                    contracts.map((contract) => new Geofence(contract))
                )
            );
    }

    getGeofenceById(id: string): Observable<Geofence> {
        const url = this.routingHelpersService.combineUrl(this.baseUrl, id);
        return this.http
            .get<GeofenceContract>(url)
            .pipe(map((contract) => new Geofence(contract)));
    }

    createGeofence(geofence: GeofenceContract): Observable<Geofence> {
        return this.http.post<{ id: string }>(this.baseUrl, geofence).pipe(
            map((response) => {
                const newGeofence = new Geofence(geofence);
                newGeofence.id = response.id;

                return newGeofence;
            })
        );
    }

    updateGeofence(geofence: GeofenceContract): Observable<Geofence> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            geofence.id || ''
        );
        return this.http
            .put<null>(url, geofence)
            .pipe(map(() => new Geofence(geofence)));
    }

    deleteGeofence(id: string): Observable<void> {
        const url = this.routingHelpersService.combineUrl(this.baseUrl, id);
        return this.http.delete<undefined>(url);
    }
}
